module.exports = __webpack_public_path__ + "img/pencil-edit.7500631c.svg";